module.exports = __webpack_public_path__ + "static/media/ic-SOW.982e2505.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-SOW.svg
// module id = 1286
// module chunks = 17